module.exports = __webpack_public_path__ + "static/img/13.0ae62f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/13.png
// module id = UofZ
// module chunks = 0